import React from "react";

interface NullProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;

}
const IconNull: React.FC<NullProps> = ({
  className,
  width,
  height,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
  >
    <g opacity="0.6">
    <mask id="mask0_670_7416" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
    <rect width="32" height="32" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_670_7416)">
    <path d="M16.3335 22.668C16.7113 22.668 17.0279 22.5402 17.2835 22.2846C17.5391 22.0291 17.6668 21.7124 17.6668 21.3346V16.0013C17.6668 15.6235 17.5391 15.3069 17.2835 15.0513C17.0279 14.7957 16.7113 14.668 16.3335 14.668C15.9557 14.668 15.6391 14.7957 15.3835 15.0513C15.1279 15.3069 15.0002 15.6235 15.0002 16.0013V21.3346C15.0002 21.7124 15.1279 22.0291 15.3835 22.2846C15.6391 22.5402 15.9557 22.668 16.3335 22.668ZM16.3335 12.0013C16.7113 12.0013 17.0279 11.8735 17.2835 11.618C17.5391 11.3624 17.6668 11.0457 17.6668 10.668C17.6668 10.2902 17.5391 9.97352 17.2835 9.71797C17.0279 9.46241 16.7113 9.33463 16.3335 9.33463C15.9557 9.33463 15.6391 9.46241 15.3835 9.71797C15.1279 9.97352 15.0002 10.2902 15.0002 10.668C15.0002 11.0457 15.1279 11.3624 15.3835 11.618C15.6391 11.8735 15.9557 12.0013 16.3335 12.0013ZM16.3335 29.3346C14.4891 29.3346 12.7557 28.9846 11.1335 28.2846C9.51128 27.5846 8.10017 26.6346 6.90017 25.4346C5.70017 24.2346 4.75017 22.8235 4.05017 21.2013C3.35017 19.5791 3.00017 17.8457 3.00017 16.0013C3.00017 14.1569 3.35017 12.4235 4.05017 10.8013C4.75017 9.17908 5.70017 7.76797 6.90017 6.56797C8.10017 5.36797 9.51128 4.41797 11.1335 3.71797C12.7557 3.01797 14.4891 2.66797 16.3335 2.66797C18.1779 2.66797 19.9113 3.01797 21.5335 3.71797C23.1557 4.41797 24.5668 5.36797 25.7668 6.56797C26.9668 7.76797 27.9168 9.17908 28.6168 10.8013C29.3168 12.4235 29.6668 14.1569 29.6668 16.0013C29.6668 17.8457 29.3168 19.5791 28.6168 21.2013C27.9168 22.8235 26.9668 24.2346 25.7668 25.4346C24.5668 26.6346 23.1557 27.5846 21.5335 28.2846C19.9113 28.9846 18.1779 29.3346 16.3335 29.3346ZM16.3335 26.668C19.3113 26.668 21.8335 25.6346 23.9002 23.568C25.9668 21.5013 27.0002 18.9791 27.0002 16.0013C27.0002 13.0235 25.9668 10.5013 23.9002 8.43464C21.8335 6.36797 19.3113 5.33464 16.3335 5.33464C13.3557 5.33464 10.8335 6.36797 8.76683 8.43464C6.70017 10.5013 5.66683 13.0235 5.66683 16.0013C5.66683 18.9791 6.70017 21.5013 8.76683 23.568C10.8335 25.6346 13.3557 26.668 16.3335 26.668Z" fill="#1C1B1F"/>
    </g>
    </g>
    </svg>
);
export default IconNull;
